import StaleSiteBanner from './StaleSiteBanner';

// The report pages' frame. It used to draw "Reports & Intelligence" and a twenty-tab strip
// that scrolled sideways; the nav panel lists the reports by group now (Back Office Review,
// wave B), so this is the stale-site notice and the page.
const ReportsLayout = ({ children }) => (
  <div data-testid="reports-layout">
    <StaleSiteBanner />
    {children}
  </div>
);

export default ReportsLayout;
